import { closest, ReplaceAroundStep, Fragment, Slice, getNodeType, } from '@tencent/exeditor3-core';
import { wrapList } from './toggle.js';
import { closestList, isListNode, joinSameListInSelection, closestListItem, getNodeInfosInSelection, getIsSameListSameItem, } from './listMethods.js';
import { NAME as listItemName } from './conf.js';
// 选区为空时，改变最近的父 list 节点的 listStyleType 属性
const changeListStyleOfWholeList = (tr, listStyleType, listName) => {
    const { from } = tr.selection;
    const $fromPos = tr.doc.resolve(from);
    const { node: listNode, pos: listNodePos } = closest($fromPos, isListNode);
    if (!listNode || listNode.attrs.listStyleType === listStyleType) {
        return;
    }
    if (listNode.type.name === listName) {
        tr.setNodeMarkup(listNodePos, null, {
            ...listNode === null || listNode === void 0 ? void 0 : listNode.attrs,
            listStyleType,
        });
    }
    joinSameListInSelection(tr);
};
// 选区最外层 listItem 是不是属于同一个 list
const isBelongToSameList = (tr, depthNodesInfo) => {
    const [firstListItem] = depthNodesInfo;
    const $pos = tr.doc.resolve(firstListItem.oldPos);
    const firstList = closestList($pos);
    for (let i = 1; i < depthNodesInfo.length; i++) {
        const secondListItem = depthNodesInfo[i];
        const $secondListpos = tr.doc.resolve(secondListItem.oldPos);
        const secondList = closestList($secondListpos);
        if (firstList !== secondList) {
            return false;
        }
    }
    return true;
};
// 整体替换
const wrapAllListItem = (tr, nodeType, listStyleType, depthNodesInfo) => {
    const outterNodesCount = depthNodesInfo.length;
    const [{ oldPos: firstOldPos }] = depthNodesInfo;
    const outterMinPos = tr.mapping.map(firstOldPos);
    const lastNode = depthNodesInfo[outterNodesCount - 1];
    const lastOldPos = tr.mapping.map(lastNode.oldPos);
    const outterMaxPos = lastOldPos + lastNode.size;
    const $outterMinPos = tr.doc.resolve(outterMinPos);
    const $outterFirstListItemPos = tr.doc.resolve(outterMinPos + 1);
    const $outterLastListItemPos = tr.doc.resolve(lastOldPos + 1);
    const outterMinPosListItem = closestListItem($outterFirstListItemPos);
    const outterMaxPosListItem = closestListItem($outterLastListItemPos);
    // 最外层的 listNode 节点
    const ouuterListNode = closestList($outterMinPos);
    const atStart = ouuterListNode.firstChild === outterMinPosListItem;
    const atEnd = ouuterListNode.lastChild === outterMaxPosListItem;
    if (ouuterListNode.attrs.listStyleType === listStyleType) {
        return;
    }
    tr.step(new ReplaceAroundStep(outterMinPos - (atStart ? 1 : 0), outterMaxPos + (atEnd ? 1 : 0), outterMinPos, outterMaxPos, new Slice((atStart
        ? Fragment.empty
        : Fragment.from(ouuterListNode.copy(Fragment.empty)))
        .append(Fragment.from(nodeType.create({ listStyleType })))
        .append(atEnd
        ? Fragment.empty
        : Fragment.from(ouuterListNode.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 1 : 2));
};
// 用 list 包裹每一个 listItem ，然后同种 list 合并
const wrapListItemOneByOne = (tr, nodeType, listStyleType, depthNodesInfo) => {
    depthNodesInfo.forEach(({ oldPos }) => {
        const listItemPos = tr.mapping.map(oldPos);
        const list = tr.doc.resolve(listItemPos).node();
        const listItem = tr.doc.resolve(listItemPos + 1).node();
        const atStart = list.firstChild === listItem;
        const atEnd = list.lastChild === listItem;
        tr.step(new ReplaceAroundStep(listItemPos - (atStart ? 1 : 0), listItemPos + listItem.nodeSize + (atEnd ? 1 : 0), listItemPos, listItemPos + listItem.nodeSize, new Slice((atStart ? Fragment.empty : Fragment.from(list.copy(Fragment.empty)))
            .append(Fragment.from(nodeType.create({ listStyleType })))
            .append(atEnd ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 1 : 2));
    });
    joinSameListInSelection(tr);
};
// 改变选区内的 listStyleType 属性，如果是跨层级选区，只改变最外面层级样式
const changeListStyleInSelection = (tr, nodeType, nodesInfo, listStyleType) => {
    if (nodesInfo.length === 0) {
        return;
    }
    // 每个 depth 深度对应的 nodes 节点
    const depthNodesInfoMap = {};
    nodesInfo.forEach((info) => {
        const { oldPos } = info;
        const nodeDepth = tr.doc.resolve(oldPos).depth;
        if (depthNodesInfoMap[nodeDepth]) {
            depthNodesInfoMap[nodeDepth].push(info);
        }
        else {
            depthNodesInfoMap[nodeDepth] = [info];
        }
    });
    Object.entries(depthNodesInfoMap).forEach(([, depthNodesInfo]) => {
        // 同层级的节点都属于是否同一个 list
        if (isBelongToSameList(tr, depthNodesInfo)) {
            wrapAllListItem(tr, nodeType, listStyleType, depthNodesInfo);
        }
        else {
            wrapListItemOneByOne(tr, nodeType, listStyleType, depthNodesInfo);
        }
    });
};
export const changeListStyle = (editor, nodeType, listStyleType, listName) => {
    editor.execute((state, dispatch) => {
        const { tr } = state;
        const { from, to } = tr.selection;
        const listItemNodeType = getNodeType(listItemName, editor.schemaInstance);
        // 获取选区内的 listItem 、纯文本节点信息
        const nodesInfo = getNodeInfosInSelection(state, nodeType, listItemNodeType);
        const isSameListSameItem = getIsSameListSameItem(nodesInfo);
        if (isSameListSameItem) {
            if (from === to) {
                changeListStyleOfWholeList(tr, listStyleType, listName);
            }
            else {
                changeListStyleInSelection(tr, nodeType, nodesInfo, listStyleType);
            }
        }
        else {
            wrapList(nodesInfo, tr, nodeType, listItemNodeType, {
                listStyleType,
            });
        }
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    });
};
//# sourceMappingURL=switchListStyleType.js.map